export const displayName = 'QC Able';

export default { displayName };
